import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';

class FetchModelAssignments {
	constructor(public readonly scope: AssignmentScope) {
		Object.freeze(this);
	}
}

export default FetchModelAssignments;
